/**
 * Component for looping over categories.
 *
 * @module
 */
import * as React from 'react';
import { CategoryContext, CategoriesContext } from '../contexts';
import { useCategories } from '../hooks';
import { CollectionChildren, LoopItemChildren, } from '../componentsInternal/utils';
/**
 * A component to display/process the total count of subcategories in a given category.
 *
 * - If a render prop is provided as the child, will pass in the total count of subcategories to the render prop function.
 * - Prints out the total count of subcategories if no render prop provided.
 *
 * @param props optional categoryId - if not provided it will use the current category context.
 */
export function TotalCount({ children, parentCategoryId }) {
    const { totalCount } = useCategories({ parentCategoryId });
    if (children)
        return React.createElement(React.Fragment, null, children({ totalCount }));
    return React.createElement(React.Fragment, null, totalCount);
}
TotalCount.displayName = 'Categories.TotalCount';
/**
 * Component to provide a way to access the current categories data via a render prop.
 *
 * - Optionally provide `parentCategoryId` to use a different collection of categories instead.
 * - Utilises [[useCategories]] under the hood.
 */
export function Collection({ children, parentCategoryId }) {
    const { categories } = useCategories({ parentCategoryId });
    return (React.createElement(CollectionChildren, { data: categories, Provider: CategoriesContext.Provider }, children));
}
Collection.displayName = 'Cateogies.Collection';
/**
 * Loops over all the top level categories and repeats the children.
 *
 * - JSX or a render prop can be passed in for children.
 */
export const Loop = ({ children, parentCategoryId, limit }) => {
    const { categories } = useCategories({ parentCategoryId, limit });
    if (!categories)
        return null;
    return (React.createElement(LoopItemChildren, { data: categories, dataKey: "category", Provider: CategoryContext.Provider }, children));
};
Loop.displayName = 'Categories.Loop';
/******************
 * Loop end
 ******************/
//# sourceMappingURL=categories.js.map